import api from "./api.service";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static getPostsForActivityFeed(startAt = 0, numberToGet = 5, tags = []) {
    let tagString = tags.length ? tags.join(",") : "";

    return this.apiRequest(
      API_SUFFIX +
        `/api/forumpost/GetPosts/${startAt}/${numberToGet}/${tagString}`,
      {},
      "GET"
    );
  }

  static getGroupDetails(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/" + groupId,
      {},
      "GET"
    );
  }

  static getGroupDetailsWithoutMembers(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/GetGroupWithoutMembers/" + groupId,
      {},
      "GET"
    );
  }

  static getGroupPosts(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/GetGroupPosts/" + groupId,
      {},
      "GET"
    );
  }

  static createPost(isForGroup, groupId, formData) {
    const endpoint = isForGroup
      ? API_SUFFIX + "/api/forumpost/CreateGroupPost/" + groupId
      : API_SUFFIX + "/api/forumpost/CreatePost";

    return this.apiRequest(endpoint, formData, "POST", true);
  }

  static myGroups() {
    return this.apiRequest(API_SUFFIX + "/api/forumgroup/mygroups", {}, "GET");
  }

  static myGroupsWithStatus() {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/mygroupswithstatus",
      {},
      "GET"
    );
  }

  static groupJoinRequests(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/GroupJoinRequests/" + groupId,
      {},
      "GET"
    );
  }

  static joinOpenGroup(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/joinopengroup/" + groupId,
      {},
      "POST"
    );
  }

  static requestToJoinGroup(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/requestToJoinGroup/" + groupId,
      {},
      "POST"
    );
  }

  static acceptInvite(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/acceptinvite/" + groupId
    );
  }

  static rejectInvite(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/rejectinvite/" + groupId
    );
  }

  static approveJoinRequest(requestId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/approvejoinrequest/" + requestId
    );
  }

  static declineJoinRequest(requestId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/declinejoinrequest/" + requestId
    );
  }

  static getPostRequestsForGroup(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumpost/grouppostrequests/" + groupId,
      {},
      "GET"
    );
  }

  static approvePostRequest(requestId) {
    return this.apiRequest(API_SUFFIX + "/api/forumpost/approve/" + requestId);
  }

  static declinePostRequest(requestId) {
    return this.apiRequest(API_SUFFIX + "/api/forumpost/decline/" + requestId);
  }

  static createGroup(name, description, membershipType, postingType) {
    return this.apiRequest(API_SUFFIX + "/api/forumgroup/creategroup", {
      name: name,
      description: description,
      membershipType: membershipType,
      postingType: postingType,
    });
  }

  static addModerators(groupId, userIds) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/addmoderators/" + groupId,
      userIds
    );
  }

  static inviteUsers(groupId, emails) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/sendinvites/" + groupId,
      emails
    );
  }

  static updateGroup(groupId, name, description, membershipType, postingType) {
    const reqData = {
      name: name,
      description: description,
      membershipType: membershipType,
      postingType: postingType,
    };

    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/updategroup/" + groupId,
      reqData,
      "PATCH"
    );
  }

  static deleteGroup(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/deletegroup/" + groupId,
      {},
      "DELETE"
    );
  }

  static reportPost(postId) {
    return this.apiRequest(API_SUFFIX + "/api/forumpost/report/" + postId);
  }

  static getReportedPosts() {
    return this.apiRequest(
      API_SUFFIX + "/api/forumpost/reportedposts",
      {},
      "GET"
    );
  }

  static ignoreReportedPost(postId, reporterId) {
    return this.apiRequest(
      API_SUFFIX +
        "/api/forumpost/ignorereportedpost/" +
        postId +
        "/" +
        reporterId,
      {},
      "POST"
    );
  }

  static deleteReportedPost(postId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumpost/deletereportedpost/" + postId,
      {},
      "POST"
    );
  }

  static deletePost(postId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumpost/DeletePost/" + postId,
      {},
      "DELETE"
    );
  }

  static leaveGroup(groupId) {
    return this.apiRequest(
      API_SUFFIX + "/api/forumgroup/LeaveGroup/" + groupId
    );
  }
}
